import { useSelector } from 'react-redux';
import { createAction, createReducer } from 'redux-act';

import type { ILocationV2 } from '@sravni/types/lib/locations';

import { DEFAULT_LOCATION } from '@src/constants/location';

import type { IGlobalState } from '.';

interface IState {
  currentLocation: ILocationV2;
}

const initState: IState = {
  currentLocation: DEFAULT_LOCATION,
};

export const setCurrentLocation = createAction<ILocationV2>('set current location');

export const locationsReducer = createReducer<IState>({}, initState).on(
  setCurrentLocation,
  (state, currentLocation) => ({
    ...state,
    currentLocation,
  }),
);

export const currentLocationSelector = (state: IGlobalState): IState['currentLocation'] =>
  state.locations.currentLocation;

export function useCurrentLocation(): IState['currentLocation'] {
  return useSelector<IGlobalState, IState['currentLocation']>(currentLocationSelector);
}
